import { useTranslation } from "@opendash/i18n";
import { Button, Form, FormItemProps } from "antd";
import { observer } from "mobx-react-lite";
import React from "react";
import { SaveTicketValues } from "../../..";
import { useFieldConfig } from "../../hooks/useFieldConfig";
import { MetaModal } from "./meta/MetaModal";

type Props = {
  type: "modal";
} & FormItemProps<SaveTicketValues>;

export const MetaInput = observer((props: Props) => {
  const t = useTranslation();
  const config = useFieldConfig("meta");
  const [open, setOpen] = React.useState(false);

  if ((config && config.hidden) || !config?.fields?.length) return <></>;

  const label =
    config?.label === "-"
      ? ""
      : config?.label || t("maintenance:ticket.create.meta.button.open");

  return (
    <>
      {props.type === "modal" ? (
        <Button onClick={() => setOpen(true)} size="small">
          {label}
        </Button>
      ) : null}
      <Form.Item<SaveTicketValues> name="meta" help={config?.help} {...props}>
        <MetaModal open={open} setOpen={setOpen} />
      </Form.Item>
    </>
  );
});
